package com.macrofocus.eflux.ui.perspective

import com.macrofocus.colormapping.implementation.SimpleColorMapping
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.toRawString
import com.macrofocus.high_d.Distributions
import com.macrofocus.high_d.distributions.DefaultDistributionsModel
import com.macrofocus.high_d.distributions.DistributionsModel
import com.macrofocus.visual.SimpleVisual
import com.macrofocus.visual.SimpleVisualObjects
import js.objects.unsafeJso
import kotlinx.browser.window
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.colormap.ColorMapFactory
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import org.molap.dataframe.DataFrame
import org.molap.json.readJson
import org.molap.subset.SubsetDataFrame
import react.FC
import react.Props
import react.useEffect
import react.useState
import web.cssom.Position
import web.cssom.px

class DistributionsPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val (distributionsModel, setDistributionsModel) = useState<DistributionsModel<Int, String, Any?, Any?>?>(null)

        val (getShiftedDateTime, _) = useProperty(dataLoader.masterDateTime)
        val shiftedDateTime = getShiftedDateTime.toRawString()

        useEffect(shiftedDateTime) {
            window.fetch("data/lines-eflux.json?datetime=$shiftedDateTime").then {
                it.text().then {
                    val dataFrame = DataFrame.readJson(it)
                    val subsetDataFrame = SubsetDataFrame(dataFrame)

                    val colorMapFactory = ColorMapFactory.instance
                    val visual = SimpleVisual(
                        SimpleVisualObjects<Int>(dataFrame), SimpleColorMapping<Int, String>(
                            colorMapFactory, dataFrame
                        )
                    )

                    setDistributionsModel(DefaultDistributionsModel<Int, String, Any?, Any?>(dataFrame, subsetDataFrame, visual))
                }
            }
        }

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            Distributions {
                this.model = distributionsModel
            }
        }
    }

}